import { onScopeDispose } from 'vue'

/**
 * 获取用于记录 `setTimeout` 返回值的对象，记录的定时器会在作用域消除时自动清理
 */
export function useSetTimeout() {
  const timer: Record<string, any> = {}

  onScopeDispose(() => {
    Object.keys(timer).forEach((key) => {
      clearTimeout(timer[key])
    })
  })

  return { timer }
}
